// manu hover open
let items = document.querySelectorAll(".header__inline-menu details");

items.forEach(item => {
  const menu = item.querySelector("ul");

  item.addEventListener("mouseenter", () => {
    item.setAttribute("open", true);
  });

  item.addEventListener("mouseleave", () => {
    item.removeAttribute("open");
  });

  if (menu) {
    menu.addEventListener("mouseleave", () => {
      item.removeAttribute("open");
    });
  }
});


function getFocusableElements(container) {
  return Array.from(
    container.querySelectorAll(
      "summary, a[href], button:enabled, [tabindex]:not([tabindex^='-']), [draggable], area, input:not([type=hidden]):enabled, select:enabled, textarea:enabled, object, iframe"
    )
  );
}



const setWidths = () => {
  if (innerWidth <= 991) return;
  document
    .querySelectorAll('.collection-card-wrapper .card__heading a')
    .forEach(el =>
      el.style.setProperty(
        '--width',
        `${Math.ceil(el.getBoundingClientRect().width)}px`
      )
    );
};
addEventListener('load', setWidths);
addEventListener('resize', setWidths);



// menu drawer close btn
document.addEventListener('DOMContentLoaded', () => {
  const button = document.querySelector('.menu-drawer-close');
  const fileInput = document.querySelector('.header__icon--menu');

  button.addEventListener('click', () => fileInput.click());
});


// custom faq
document.addEventListener("DOMContentLoaded", () => {
  const accordionItemHeaders = document.querySelectorAll(".accordion-item-header");

  if (accordionItemHeaders.length > 0) {
    const firstHeader = accordionItemHeaders[0];
    const firstBody = firstHeader.nextElementSibling;

    firstHeader.classList.add("active");
    firstBody.style.maxHeight = firstBody.scrollHeight + "px";
  }

  accordionItemHeaders.forEach(accordionItemHeader => {
    accordionItemHeader.addEventListener("click", event => {

      const currentlyActiveAccordionItemHeader = document.querySelector(".accordion-item-header.active");

      if (currentlyActiveAccordionItemHeader && currentlyActiveAccordionItemHeader !== accordionItemHeader) {
        currentlyActiveAccordionItemHeader.classList.remove("active");
        currentlyActiveAccordionItemHeader.nextElementSibling.style.maxHeight = 0;
      }

      accordionItemHeader.classList.toggle("active");

      const accordionItemBody = accordionItemHeader.nextElementSibling;

      if (accordionItemHeader.classList.contains("active")) {
        accordionItemBody.style.maxHeight = accordionItemBody.scrollHeight + "px";
      } else {
        accordionItemBody.style.maxHeight = 0;
      }

    });
  });
});



document.addEventListener('click', function (event) {
  const clickedToggle = event.target.closest('#CustomSortToggle');
  const clickedItem = event.target.closest('.custom-sort-item');
  const clickedOverlay = event.target.closest('.custom-sort-overlay, .custom-sort-close');

  const sortDropdown = document.querySelector('.custom-sort-dropdown');
  const sortList = document.getElementById('CustomSortList');
  const sortInput = document.getElementById('SortByHiddenInput');
  const sortForm = document.getElementById('FacetFiltersForm');
  const activeLabel = document.getElementById('CustomSortActiveLabel');

  // 1 — Toggle open/close
  if (clickedToggle) {
    event.preventDefault();
    sortList?.toggleAttribute('hidden');
    clickedToggle.classList.toggle('active');
    return;
  }

  // 2 — Click on item
  if (clickedItem && sortInput && sortForm) {
    const newValue = clickedItem.dataset.value;

    if (newValue !== sortInput.value) {
      sortInput.value = newValue;
      if (activeLabel) activeLabel.textContent = clickedItem.textContent;

      document.querySelectorAll('.custom-sort-item')
        .forEach(li => li.classList.remove('active'));

      clickedItem.classList.add('active');
      sortList?.setAttribute('hidden', true);
      document.getElementById('CustomSortToggle')?.classList.remove('active');

      const inputEvent = new Event('input', { bubbles: true });
      sortForm.dispatchEvent(inputEvent);
    }
    return;
  }

  // 2.5 — Click overlay (close dropdown)
  if (clickedOverlay) {
    sortList?.setAttribute('hidden', true);
    document.getElementById('CustomSortToggle')?.classList.remove('active');
    return;
  }

  // 3 — Click outside
  if (!event.target.closest('.custom-sort-dropdown')) {
    sortList?.setAttribute('hidden', true);
    document.getElementById('CustomSortToggle')?.classList.remove('active');
  }
});

// Confetti Animation Effect and popup open close js for VIP Page
document.addEventListener("DOMContentLoaded", function () {
  const params = new URLSearchParams(window.location.search);
  const popup = document.getElementById("thankyou-popup");
  if (params.get("contact_posted") === "true" && popup) {
    popup.style.display = "flex";
    const canvas = document.getElementById("confetti-canvas");
    const myConfetti = confetti.create(canvas, {
      resize: true,
      useWorker: true
    });
    const duration = 2000;
    const end = Date.now() + duration;
    (function frame() {
      myConfetti({
        particleCount: 30,
        angle: 60,
        spread: 70,
        startVelocity: 40,
        origin: { x: 0, y: 0.8 }
      });
      myConfetti({
        particleCount: 30,
        angle: 120,
        spread: 70,
        startVelocity: 40,
        origin: { x: 1, y: 0.8 }
      });
      if (Date.now() < end) {
        requestAnimationFrame(frame);
      }
    })();
    window.history.replaceState({}, document.title, window.location.pathname);
  }
  document.getElementById("popup-close")?.addEventListener("click", function () {
    popup.style.display = "none";
  });
});



document.addEventListener('DOMContentLoaded', () => {
  const searchDrawer = document.querySelector('.search-drawer');

  // Open drawer
  searchDrawer.addEventListener('click', () => {
    searchDrawer.classList.add('active');
  });

  // Close drawer
  document.addEventListener('click', (e) => {
    if (e.target.closest('.modal-overlay') || e.target.closest('.search-modal__close-button')) {
      e.stopPropagation();
      searchDrawer.classList.remove('active');
    }
  });

});